export enum EnvServer {
    Local = 'local',
    Dev = 'dev',
    Prod = 'prod',
    Release = 'release',
}
